"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpsToDoMetaModel = void 0;
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const MetaModel_1 = __importDefault(require("../MetaModel"));
exports.OpsToDoMetaModel = new MetaModel_1.default({
    name: () => lib_i18n_1.default.t('ops'),
    queryName: 'opsToDo',
    alwaysGetGqlFields: `id,
		title,
		description,
		startFrom,
		completeBy,
		actualStart,
		actualComplete,
		createdDate,
		updatedDate,
		approvedDate,
		closedDate,
		hasImage,
		form,
		place { id, title, timezone },
        staff {  id, title, profileImageUrl, hasProfileImage },
        teams { id, title },
        positions { id, title},
		allPTsPermitted,
		opDefinitionId,
		awaitingApproval,
		opScheduleId,
		type,
		createdBy {  id, title, profileImageUrl, hasProfileImage },
		startedBy {  id, title, profileImageUrl, hasProfileImage },
	    updatedBy {  id, title, profileImageUrl, hasProfileImage },
	    submittedBy {  id, title, profileImageUrl, hasProfileImage },
	    approvedBy {  id, title, profileImageUrl, hasProfileImage },
	    closedBy {  id, title, profileImageUrl, hasProfileImage },
		issues { id, status, flag },
		isAdhoc,
		grade,
		finalScoreTotal,
		finalScoreMax,
		percComplete,
		opPerformedLocation,
		isScoreEnabled,
		isScorePublic,
		gradingMethod,
		isGradingPublic,
		allowIssuesAndNotes,
		canBePerformedOnlyOnNative,
		completedOnDeviceType,
		passFailStatus`,
    filterables: [QueryFieldKey_1.default.OPDEFINITION, QueryFieldKey_1.default.PLACE, QueryFieldKey_1.default.TEAM, QueryFieldKey_1.default.POSITION, QueryFieldKey_1.default.OP_STATUS],
    groupables: [],
    fields: [],
});
exports.default = exports.OpsToDoMetaModel;
